import { atom } from 'jotai';

import { MessageEventPageInfo, MessagePane } from './types';

export const messageEventPageInfoState = atom<MessageEventPageInfo>({
  page: 1,
  perPage: 10,
  totalPage: 1,
});

export const messagePaneState = atom<MessagePane>({
  currentPanel: 'initial',
  messageId: null,
  draftMessageId: null,
  patient: null,
  webPatient: null,
});
